import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '内容导航',
    links: [
      { label: '热门电影', to: '/category/dianying' },
      { label: '电视剧场', to: '/category/dianshiju' },
      { label: '综艺节目', to: '/category/zongyi' },
      { label: '动漫番剧', to: '/category/dongman' },
      { label: '纪录片', to: '/category/jilupian' },
      { label: '短视频', to: '/category/duanshipin' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '平台优势', to: '/about' },
      { label: '联系我们', to: '/about#contact' },
      { label: '加入我们', to: '/about' },
      { label: '隐私政策', to: '/about' },
      { label: '用户协议', to: '/about' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '常见问题', to: '/' },
      { label: '播放帮助', to: '/about' },
      { label: '账号问题', to: '/about' },
      { label: '投诉建议', to: '/about#contact' },
      { label: '内容合作', to: '/about#contact' },
      { label: '广告合作', to: '/about#contact' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-xl font-heading text-background-50">蘑菇视频</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              官方正版视频平台入口<br />
              提供最新影视、综艺、短视频内容<br />
              免费观看海量高清视频
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 蘑菇视频 MoguTV. All rights reserved. 本站内容仅供学习交流使用
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">京ICP备2024XXXXXX号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">网络视听许可证</a>
          </p>
        </div>
      </div>
    </footer>
  );
}